import { useQuery } from "@tanstack/react-query";
import {
  WELCOME_OFFER_UNAVAILABLE,
  type WelcomeCouponOffer,
} from "@/libs/welcome-coupon/getWelcomeOffer";

export async function fetchWelcomeCouponOffer(): Promise<WelcomeCouponOffer> {
  // ⚠️ **끝 슬래시를 붙인다.** 이 사이트는 `next.config.mjs` 의 `trailingSlash: true` 라
  // 슬래시 없이 부르면 **308 을 한 번 더 탄다**(`refetchInterval: 30s` 폴링마다 왕복 2회).
  // 형제인 `feature-flag-query` 도 `/api/feature-flag/` 로 붙여 부른다.
  // ⚠️ 헷갈리기 쉬운데 **mgmt 로 가는 상류 경로는 반대로 슬래시를 붙이면 401** 이다
  // (`getWelcomeOffer` 의 KDoc). 규칙이 경로마다 정반대라는 점에 주의.
  const res = await fetch("/api/welcome-coupon-offer/");
  if (!res.ok) return WELCOME_OFFER_UNAVAILABLE;
  return (await res.json()) as WelcomeCouponOffer;
}

/**
 * 신규 가입 웰컴 쿠폰 오퍼. **혜택을 약속하는 표면은 이걸 통해서만 판정한다**
 * (직접 쓰지 말고 `useWelcomeCouponIssuing` 을 쓸 것 — 그쪽이 fail-closed 를 강제한다).
 *
 * 캐시 설정은 피처플래그 훅(`useFeatureFlags`)과 같은 근거다.
 * - `staleTime: 10s` — 캠페인을 끄는 것이 **배포 없이** 되어야 하므로 길게 잡을 수 없다.
 *   대신 마운트 파동마다 재요청되는 것은 막는다(구독처가 팝업·배지·카트·PDP 로 여럿이다).
 * - `refetchInterval: 30s` — `refetchOnMount` 는 **stale 일 때만** 리페치라, 리마운트·포커스가
 *   없는 화면(메인을 열어둔 채 방치)에서는 상한이 보장되지 않는다.
 *
 * 서버 라우트가 실패를 200 + `available:false` 로 흡수하므로 `retry` 를 늘릴 이유가 없다.
 */
export function useWelcomeCouponOfferQuery() {
  return useQuery<WelcomeCouponOffer>({
    queryKey: ["welcome-coupon-offer"],
    queryFn: fetchWelcomeCouponOffer,
    staleTime: 10_000,
    refetchOnMount: true,
    refetchInterval: 30_000,
  });
}
